import { render, staticRenderFns } from "./CommercialContactForm.vue?vue&type=template&id=fb4a9bc0&lang=pug&"
import script from "./CommercialContactForm.vue?vue&type=script&lang=js&"
export * from "./CommercialContactForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports